import VariablePaymentType from "@/enums/VariablePaymentType";
class Salary {
    constructor(salary) {
        Object.assign(this, salary, {});
    }
    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
    get totalSalary() {
        return this.fixedPayment + this.variablePayment;
    }
    get paymentType() {
        if (this.variablePaymentType === undefined) {
            return VariablePaymentType.None;
        }
        return VariablePaymentType[this.variablePaymentType];
    }
}
export default Salary;
